import React from "react";
import styles from "../Contact/Contact.module.css";
import { HiOutlineMail } from "react-icons/hi";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";

export const Contact = () =>
{
  const { t, i18n } = useTranslation("global");

  const form = useRef();

  const sendEmail = (e) =>
  {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_d3fjx5g",
        "template_jtjxrr1",
        form.current,
        "eD-aT4oF8WVmKVp65"
      )
      .then(
        (result) =>
        {
          console.log(result.text);
          toast.success("Mensaje enviado exitósamente", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          e.target.reset();
        },
        (error) =>
        {
          console.log(error.text);
          toast("Error, intente nuevamente");
        }
      );
  };

  return (
    <>
      <div className={styles.background} id="contact">


         <div className={styles.icon}>
          <HiOutlineMail />
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            required
            placeholder=" NOMBRE"
            name="name"
          />
          <input
            type="email"
            required
            placeholder=" EMAIL"
            name="email"
          />
          <textarea
            required
            name="message"
            id=""
            cols="30"
            rows="10"
            placeholder="MENSAJE"
          ></textarea>
          <button type="submit" value="Send" className={styles.btn}>
            {t("buttons.send")}
          </button>
        </form>
      </div>
    </>
  );
};
